export default {
     'services' : {
          'url': "https://nequi-dot-geodata-pruebas.appspot.com",
          'modules': {
               'categories': {
                    'all': "/api/categories"
               },
               'cities': {
                    'all': "/api/cities",
                    'by_department': "/api/cities/{deptName}/dpto"
               },
               'departments': {
                    'all': "/api/departments"
               },
               'points':{
                    'by_city': "/api/points/{cityCode}/city",
                    'around_location': "/api/points/{lng}/lng/{lat}/lat/{limit}/limit"
               }
          },
          getService(module, service){
               return this.url + this['modules'][module][service];
          }
     }
}
